import { Box } from '@mui/material'
import ExtraInfoGuestActions from '~/src/components/auth/extra-info/guest/ExtraInfoGuestActions'
import ExtraInfoGuestFields from '~/src/components/auth/extra-info/guest/ExtraInfoGuestFields'
import { GuestFormInterface } from '~/src/types/forms/GuestFormInterface'
import { FormikProps, useFormik } from 'formik'
import useGuestForm from '~/src/hooks/forms/guest-form/useGuestForm'
import useAuthenticationFlowDialogs from '~/src/hooks/auth/flow/useAuthenticationFlowDialogs'
import { useEoState } from '~/src/hooks/useEoState'
import {
  AUTHENTICATION_FLOW_STATE,
  AuthenticationFlowCustomer,
  AuthenticationFlowState
} from '~/src/stores/authentication-flow'
import FormError from '~/src/components/error/FormError'
import { useEffect } from 'react'

interface Props {
  fieldsColor?: 'container' | 'content',
  showBackButton?: boolean,
}

const ExtraInfoGuestForm = ({ fieldsColor = 'content', showBackButton = false }: Props) => {
  const { next } = useAuthenticationFlowDialogs()
  const [ authenticationFlowState, setAuthenticationFlowState ] = useEoState<AuthenticationFlowState>(AUTHENTICATION_FLOW_STATE)
  const { initialValues, validationSchema } = useGuestForm()
  const formik: FormikProps<GuestFormInterface> = useFormik<GuestFormInterface>({
    initialValues,
    validationSchema,
    onSubmit: (values: GuestFormInterface) => {
      setAuthenticationFlowState((state: AuthenticationFlowState) => ({
        ...state,
        customer: {
          email: values.email ?? null,
          phone: values.phone ?? null,
          firstName: values.firstName ?? null,
          lastName: values.lastName ?? null,
          company: values.company ?? null
        } as AuthenticationFlowCustomer
      }))

      next()
    }
  })

  useEffect(() => {
    setAuthenticationFlowState((state: AuthenticationFlowState) => ({
      ...state,
      customer: {
        ...(state.customer),
        email: formik.values.email ?? undefined,
        firstName: formik.values.firstName ?? undefined,
        lastName: formik.values.lastName ?? undefined,
        phone: formik.values.phone ?? undefined
      }
    }))
  }, [ formik.values ])

  return (
    <>
      {authenticationFlowState.errors && <FormError errors={authenticationFlowState.errors} />}

      <Box
        component='form'
        onSubmit={formik.handleSubmit}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 5,
          mt: 2
        }}
      >
        <ExtraInfoGuestFields
          form={formik}
          fieldsColor={fieldsColor}/>

        <ExtraInfoGuestActions
          form={formik}
          loading={authenticationFlowState.isLoading}
          showBackButton={showBackButton}/>
      </Box>
    </>
  )
}

export default ExtraInfoGuestForm
